// Public Cognito OIDC configuration (ADR-0011). Only public `VITE_*` values —
// never a client secret or AWS credentials. `cognitoConfig` is `null` when the
// essential values are missing so the app can FAIL CLOSED (no stub identity) —
// e.g. on a personal deployed stage that owns no Cognito resources.

export interface CognitoPublicConfig {
	authority: string
	clientId: string
	redirectUri: string
	scope: string
	/** Managed Login domain — used by hosted logout. */
	domain?: string
	/** Post-logout return URI — used by hosted logout. */
	logoutUri?: string
}

const authority = import.meta.env.VITE_COGNITO_AUTHORITY
const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID
const redirectUri = import.meta.env.VITE_COGNITO_REDIRECT_URI

// The three essentials are required for the Authorization Code + PKCE flow.
export const cognitoConfig: CognitoPublicConfig | null =
	authority && clientId && redirectUri
		? {
				authority,
				clientId,
				redirectUri,
				scope: import.meta.env.VITE_COGNITO_SCOPES || 'openid email profile',
				domain: import.meta.env.VITE_COGNITO_DOMAIN || undefined,
				logoutUri: import.meta.env.VITE_COGNITO_LOGOUT_URI || undefined,
			}
		: null

export const isCognitoConfigured = cognitoConfig !== null
